import { useRootAppStore } from "@hooks";

export function useCreate24hLock() {
	const rootStore = useRootAppStore();
	const create24hLock = async () => {
		await rootStore.user24hLockStore.lockUser();
	};

	return {
		create24hLock,
	};
}
